<template>
  <div style="cursor: pointer;">

    <v-row dir="ltr">
      <v-col @click="$router.push('sub/glasses')" style="overflow: hidden" cols="12" md="6" lg="6" xl="6"
             class="position-relative overflow-hidden  pa-0 pr-3 mb-3">
        <div class="overflow-hidden">
          <v-img class="company-image overflow-hidden" :width="$vuetify.breakpoint.width>960?'50vw':'100vw'"
                 :height="$vuetify.breakpoint.width>960?'40vw':'100vw'"
                 :src=" grid.categories.find(item=>item.id ==185).photo"></v-img>
          <div class="title-box" style="right: 12px!important;">

            <h6 class="text-right mt-3 white--text font-weight-bold">
              {{ grid.categories.find(item=>item.id ==185).title }}
            </h6>
            <p dir="rtl" class="white--text mt-4 mb-3">{{ grid.categories.find(item=>item.id ==185).seo_description }}</p>
          </div>
        </div>

      </v-col>
      <v-col cols="12" md="6" lg="6" xl="6" class="pa-0">
        <v-row>
          <v-col @click="$router.push('/sub/light-blocks/construction/product/ajor')" cols="6" class="overflow-hidden position-relative pr-3 mb-3">
            <div class="overflow-hidden">
              <v-img class="company-image overflow-hidden" :width="$vuetify.breakpoint.width>960?'25vw':'50vw'"
                     :height="$vuetify.breakpoint.width>960?'15vw':'50vw'"
                     :src=" grid.categories.find(item=>item.id ==21).photo" cover></v-img>
              <div class="title-box" style="right: 12px;">
                <h6 class="text-right mt-3 white--text font-weight-bold">
                  {{ grid.categories.find(item=>item.id ==21).title }}
                </h6>
                <p dir="rtl" class="white--text mt-4 mb-3 text-right">
                  {{ grid.categories.find(item=>item.id ==21).seo_description }}
                  
                </p>
              </div>
            </div>
          </v-col>
          <v-col @click="$router.push('/sub/light-blocks')" cols="6" class="overflow-hidden position-relative mb-4">
            <v-img class="company-image overflow-hidden" :width="$vuetify.breakpoint.width>960?'25vw':'50vw'"
                   :height="$vuetify.breakpoint.width>960?'20vw':'50vw'"
                   :src=" grid.categories.find(item=>item.id ==23).photo"></v-img>
            <div class="title-box">

              <h6 class="text-right mt-3 white--text font-weight-bold">
                {{ grid.categories.find(item=>item.id ==23).title }}
              </h6>
              <p dir="rtl" class="white--text mt-4 mb-3 text-right">
                {{ grid.categories.find(item=>item.id ==23).seo_description }}
                
              </p>
            </div>

          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="overflow-hidden position-relative mb-3"
                 @click="$router.push('/sub/light-blocks/construction/products')">
            <div class="overflow-hidden">
              <v-img class="company-image" :width="$vuetify.breakpoint.width>960?'50vw':'100vw'"
                     :height="$vuetify.breakpoint.width>960?'20vw':'50vw'"
                     :src="grid.categories.find(item=>item.id ==19).photo"></v-img>
              <div class="title-box">
                <h6 dir="auto" class="text-right mt-3 white--text font-weight-bold">
                  {{ grid.categories.find(item=>item.id ==19).title }}
                </h6>
                <p dir="rtl" class="white--text mt-4 mb-3">
                  {{ grid.categories.find(item=>item.id ==19).seo_description }}
                  
                </p>
              </div>
            </div>

          </v-col>
          <!--          <v-col cols="6" class="overflow-hidden position-relative">
                      <v-img class="company-image" :width="$vuetify.breakpoint.width>960?'25vw':'50vw'"
                             :height="$vuetify.breakpoint.width>960?'25vw':'50vw'"
                             src="../../../assets/images/product-images/grid2.jpg.webp"></v-img>

                    </v-col>-->
        </v-row>
      </v-col>
      <v-col cols="12" md="6" lg="6" xl="6" class="pa-0">
        <v-row>
          <v-col  cols="6" class="overflow-hidden position-relative pr-3 mb-3">
            <router-link to="/material/single/937">
              <div class="overflow-hidden">
                <v-img class="company-image" :width="$vuetify.breakpoint.width>960?'25vw':'50vw'"
                       :height="$vuetify.breakpoint.width>960?'20vw':'50vw'"
                       cover
                       :src="grid.categories.find(item=>item.id ==25).photo"
                ></v-img>
                <div class="title-box" style="right: 12px;">
                  <h6 class="text-right mt-3 white--text font-weight-bold">
                    {{grid.categories.find(item=>item.id ==25).title }}
                  </h6>
                  <p dir="rtl" class="white--text mt-4 mb-3 text-right">
                    {{grid.categories.find(item=>item.id ==25).seo_description }}
                    
                  </p>
                </div>
              </div>
            </router-link>


          </v-col>
          <v-col cols="6" class="overflow-hidden position-relative pr-3 mb-3">

            <router-link to="/material/single/938">
              <div class="overflow-hidden">
                <v-img class="company-image" :width="$vuetify.breakpoint.width>960?'25vw':'50vw'"
                       :height="$vuetify.breakpoint.width>960?'20vw':'50vw'"
                       :src=" grid.categories.find(item=>item.id ==22).photo"></v-img>
                <div class="title-box" style="right: 12px;">

                  <h6 class="text-right mt-3 white--text font-weight-bold">
                    {{ grid.categories.find(item=>item.id ==22).title }}
                  </h6>
                  <p dir="rtl" class="white--text mt-4 mb-3 text-right">
                    {{ grid.categories.find(item=>item.id ==22).seo_description }}
                  </p>
                </div>
              </div>
            </router-link>


          </v-col>
        </v-row>
        <v-col cols="12" class="overflow-hidden position-relative pr-3">

          <router-link to="/material/single/939">
            <div class="overflow-hidden">
              <v-img class="company-image" :width="$vuetify.breakpoint.width>960?'50vw':'100vw'"
                     :height="$vuetify.breakpoint.width>960?'20vw':'50vw'"
                     :src="grid.categories.find(item=>item.id ==24).photo"
              ></v-img>
              <div class="title-box" style="right: 12px;">
                <h6 class="text-right mt-3 white--text font-weight-bold">
                  {{ grid.categories.find(item=>item.id ==24).title }}
                </h6>
                <p dir="rtl" class="white--text mt-4 mb-3 text-right">
                  {{ grid.categories.find(item=>item.id ==24).seo_description }}
                </p>
              </div>
            </div>
          </router-link>


        </v-col>
      </v-col>
      <v-col cols="12" md="6" lg="6" xl="6" class="overflow-hidden position-relative pa-0">
        <v-img class="company-image" :width="$vuetify.breakpoint.width>960?'50vw':'100vw'"
               :height="$vuetify.breakpoint.width>960?'40vw':'100vw'"

               :src="grid.categories.find(item=>item.id ==20).photo"></v-img>
        <div class="title-box">
          <h6 class="text-right mt-3 white--text font-weight-bold">
            {{ grid.categories.find(item=>item.id ==20).title }}
          </h6>
          <p dir="rtl" class="white--text mt-4 mb-3 text-right">
            {{ grid.categories.find(item=>item.id ==20).seo_description }}
          </p>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: 'ProductsGrid',
  computed: {
    ...mapState({
      grid: state => state.homeManagement.grid,
    })
  },
}
</script>
<style scoped>


@media screen and (max-width: 960px) {
  h2 {
    font-size: 16px;
  }

  h3 {
    font-size: 12px;
  }
}

@media screen and (min-width: 960px) {
  h1 {
    font-size: 54px;
  }
}

.over-text-bottom {
  padding: 16px 8px;
  position: absolute;
  bottom: 16px;
  left: 16px;
  right: 16px;
}

.over-text-top {

  padding: 16px 8px;
  position: absolute;
  top: 32px;
  left: 16px;
  right: 16px;
}

.over-text-center {
  padding: 16px 8px;
  position: absolute;
  top: 40%;
  left: 16px;
  right: 16px;
}

.over-text-center-left {
  padding: 16px 8px;
  position: absolute;
  top: 40%;
  left: 32px;

}

.position-relative {
  position: relative;
  -webkit-animation: fadein 6s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 6s; /* Firefox < 16 */
  -ms-animation: fadein 6s; /* Internet Explorer */
  -o-animation: fadein 6s; /* Opera < 12.1 */
  animation: fadein 6s;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

h6 {
  margin: 0px !important;
  padding: 0px !important;
}
</style>
